<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            dark
            class="nextBtn"
            color="blue-grey"
            large
          v-bind="attrs"
          v-on="on"
        >
        Proceed
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <b><span class="headline ">Confirm</span></b>
        </v-card-title>
        <v-card-text>
          <v-container>
                <hr/>
            <v-row>
               <v-col cols="12" sm="4">
                 <p><b>Network</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <div @click="Setnetwork('MTN')" class="network">
                      <img v-if="network == 'MTN'" src="../assets/mtn.png" alt="teller logo" width="30" height="25">
                      <img v-if="network == 'GLO'" src="../assets/glo.png" alt="teller logo" width="30" height="25">
                      <img v-if="network == 'Etisalat'" src="../assets/9m.png" alt="teller logo" width="30" height="25">
                      <img v-if="network == 'Airtel'" src="../assets/airtel.png" alt="teller logo" width="30" height="25">
                      <p v-if="network != 'Etisalat'" class="mt-3">{{network}}</p>
                      <p v-else class="mt-3">9MOBILE</p>
                    </div>
                </v-col>
                    <v-col cols="12" sm="4">
                 <p><b>Phone Number</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{phone}}</p>
                </v-col>
                    <v-col cols="12" sm="4">
                 <p><b>Amount</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{DisplayCurrency(amount)}}</p>
                </v-col>
            </v-row>
                <hr/>
          </v-container>
          <small>*Teller</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn dark color="blue darken-1" @click="BuyAirTime()">Proceed</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import currencyFormatter from 'currency-formatter'

  export default {
    props:['phone', 'amount', 'network'],
    data: () => ({
      dialog: false,
    }),
    methods: {
      BuyAirTime(){
          let payload = {
          customerID: this.User.customerID, 
          pin: this.User.pin,
          phoneNumber:this.phone,
          amount:this.amount,
          network:this.network,
          route: this.$router
        }
        this.$store.dispatch('BuyAirTime', payload)
        this.dialog = false;
      },
       DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
    },
    },

    computed: {
      User () {
        return this.$store.getters.getUser
        },
     }
  }
</script>
<style scoped>
.nextBtn{
     background-color: #AD1684 !important;
     border-radius: 10px;
     text-transform: none;
}
.network{
  display: flex;
  align-items: center;
}
img{
  margin: 3px;
}
</style>